import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import BillListService from './BillListService';
import { isRequired } from '../../../core/validations';
import FormService from '../../../core/services/FormService';

class BillCancellationDialogService {
  form = new FormService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
    this.form.validations = {
      cancellationReason: [isRequired],
    };
  }

  handleOpen = action((bill) => {
    this.form.setInitialValues(bill);
    this.isOpen = true;
    this.form.reset();
  });

  handleCancelBill = action(() => {
    this.submit
      .fetch({
        method: 'put',
        url: `/bills/${this.form.getValue('id')}/cancel`,
        apiVersion: 'v2',
        body: {
          cancellationReason: this.form.getValue('cancellationReason'),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification(`Bill successfully canceled.`, 'success');
          this.isOpen = false;
          BillListService.load();
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error cancelling the bill.`, 'error');
        }
      });
  });

  handleCancel = action(() => {
    this.isOpen = false;
  });
}

const billCancellationDialogService = new BillCancellationDialogService();
export default billCancellationDialogService;
